import { render } from "./News18.vue?vue&type=template&id=d0e992c0"
import script from "./News18.vue?vue&type=script&lang=js"
export * from "./News18.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__